<template>
  <div class="drawer-item" @click="closeDrawer">
    <slot/>
  </div>
</template>

<script>
export default {
  methods: {
    closeDrawer () {
      this.$parent.close()
    }
  }
}
</script>

<style lang='scss' scoped>
.drawer-item {
  cursor: pointer;
  text-align: left;
  color: white;
  font-size: 1.25rem;
  padding: .25rem;
  padding-left: 1.25rem;
}
</style>
